<template>
  <div class="listcontainer">
    <div v-if="items.intro.length > 0 " class="sectionTitle"> Introduction to the process </div>
        <div v-for="item in items.intro" class="itemsList">
          <div class="item" v-on:click="downloadFile(item)">
            <div class="itemtitle">
              <span v-html="resourceIcon" style="margin-right: 5px;"></span>
              <div>{{ item.name }}</div>
            </div>
            <div class="actions">
              <span v-html="downloadIcon"></span>
            </div>
          </div>
        </div>
    <div v-if="items.SPMA.length > 0 " class="sectionTitle"> Benchmark Assessment Tool

        <span class="tooltipIcon" v-on:click="this.tooltipToggle"> Whats This? </span>
      <transition name="fade">
        <div v-if="this.tooltipShow" class="tooltipBox" v-click-outside="this.tooltipToggle">
          <div class="tooltipTitle" >
            <div   style="font-weight: bold; margin-bottom: 10px;">Benchmark Assessment principles:</div>
            <span style="flex:auto"></span>
<!--            <div class="CloseButton" v-on:click="tooltipToggle"></div>-->

            <span class="closeIcon" v-html="closeIcon" v-on:click="tooltipToggle" ></span>
          </div>
          <ul>
            <li> This is a collaborative assessment, not an audit.</li>
            <li> The assessment should be done by a small team (2 to 5 people).</li>
            <li> The team should include Engineering and Operations representatives</li>
            <li> Work together to do a fair and honest assessment.</li>
            <li> The assessment should be done while walking the process.</li>
            <li> An improvement plan is required for any criteria that do not meet the minimum standard.</li>
          </ul>
        </div>
      </transition>

    </div>

    <div v-for="item in items.SPMA" class="itemsList">
      <div class="item"  v-on:click="downloadFile(item)">
        <div class="itemtitle">
          <span v-html="resourceIcon" style="margin-right: 5px;"></span>
          <div>{{ item.name }}</div>
        </div>
        <div class="actions">
          <span v-html="downloadIcon"></span>
        </div>
      </div>
    </div>
    <div v-if="items.PFMEA && items.PFMEA.length > 0 " class="sectionTitle"> Reference PFMEA </div>
    <div v-for="item in items.PFMEA" class="itemsList">
      <div class="item"  v-on:click="downloadFile(item)">
        <div class="itemtitle">
          <span v-html="resourceIcon" style="margin-right: 5px;"></span>
          <div>{{ item.name }}</div>
        </div>
        <div class="actions">
          <span v-html="downloadIcon"></span>
        </div>
      </div>
    </div>
    <div v-if="items.Foundation.length > 0 " class="sectionTitle"> Foundation Control plan </div>
    <div v-for="item in items.Foundation" class="itemsList">
      <div class="item"  v-on:click="downloadFile(item)">
        <div class="itemtitle">
          <span v-html="resourceIcon" style="margin-right: 5px;"></span>
          <div>{{ item.name }}</div>
        </div>
        <div class="actions">
          <span v-html="downloadIcon"></span>
        </div>
      </div>
    </div>
    <div v-if="items.links.length > 0 " class="sectionTitle"> Links </div>
           <p v-if="items.links.length > 0 "> Rolls-Royce is not responsible for any material contained on the following external websites and we don't accept any liability in connection with any information or services they provide. We can't guarantee that these links will work all of the time. </p>
    <div v-for="item in items.links" class="itemsList">
      <div class="item">
        <div class="itemtitle">
          <span v-html="resourceIcon" style="margin-right: 5px;"></span>
          <div class="contactRow">
          <div >{{ item.name }}</div>
          <a :href="item.url" target="_blank" class="urlLink">{{ item.url }}</a>
          </div>
        </div>
<!--        <div class="actions">-->
<!--          <span v-html="downloadIcon"></span>-->
<!--        </div>-->

      </div>
    </div>
    <!-- <div  class="sectionTitle"> Contacts </div> -->
    <!-- <p v-if="items.contacts.length == 0 "> For further information please contact your Rolls-Royce Purchase representative. </p> -->
<!--    below is commented until functionality is required -->
<!--    <div v-if="items.contacts.length > 0 " class="sectionTitle"> Contacts </div>-->
<!--    <div v-for="item in items.contacts" class="itemsList">-->
<!--      <div class="item">-->
<!--        <div class="itemtitle">-->
<!--         <span v-html="peopleIcon"  class="ppleIcon"></span>-->
<!--          <div class="contactCard">-->
<!--            <div class="contactRow"><span class="contactSub">Name:</span> <div>{{ item.name }}</div> </div>-->
<!--            <div class="contactRow"> <span class="contactSub">Title: </span>-->
<!--              <div>{{ item.title }}</div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="contactCard">-->
<!--            <div class="contactRow"> <span class="contactSub">Email: </span> <a :href="'mailto:'+ item.email">{{ item.email }}</a></div>-->
<!--            <div class="contactRow"> <span class="contactSub">Phone:</span><div>{{ item.phone }}</div>            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--      </div>-->
<!--    </div>-->

  </div>
</template>

<script>
import axios from 'axios';
import iconService from "../services/iconService";
import vClickOutside from 'v-click-outside'
export default {
  name: "ListComponent",

  data () {
    return {
      downloadIcon: iconService.icons.Download,
      resourceIcon: iconService.icons.Resource,
      peopleIcon: iconService.icons.People,
      closeIcon: iconService.icons.CloseSmall,
      code: '',
      email:'',
      tooltipShow: false
    }
  },
  props:{
    items: {}
  },
  mounted() {

  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  methods: {

    downloadFile(item){
      const filepath = item.url;
      const fileName = item.name;

      axios.post(process.env.VUE_APP_API_URL+'/resources/download', {
        path: filepath
      },{
        responseType: "blob",
        headers:{'Content-Type': 'application/json',
          'email': this.getCookie('email'),
          'usertoken': this.getCookie('usertoken')}
      }).then((response)=>{
        let blob = new Blob([response.data], ),
            downloadUrl = window.URL.createObjectURL(blob),
            filename = fileName,
            disposition = response.headers["content-disposition"];

        if (disposition && disposition.indexOf("attachment") !== -1) {
          let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
              matches = filenameRegex.exec(disposition);

          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

        let a = document.createElement("a");
        if (typeof a.download === "undefined") {
          window.location.href = downloadUrl;
        } else {
          a.href = downloadUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
        }



      }).catch((error)=>{
        console.log("error", error)
      })
    },
    tooltipToggle(){
      this.tooltipShow = !this.tooltipShow;
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  },
}
</script>
<style scoped>
.listcontainer{
  overflow-y: scroll;
  display: block;
  width: 97%;
  height: 600px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 20px;
}
 .sectionTitle{
   color:#333333;
   font-size: 24px;
   margin-top: 60px;
   margin-bottom: 25px;
   position: relative;
 }
 .itemsList{
   width: 95%;
 }
 .item{
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   align-items: center;
   width: 100%;
   height: 60px;
   font-size: 18px;
   color: #8A8A8F;
   border-top: 1px solid #c8c7cc;
   padding: 10px;
   cursor: pointer;
 }
 .itemtitle{
   display: flex;
   flex-direction: row;
   align-items: center;
 }
 .contactCard{
   display: flex;
   flex-direction: column;
   margin-left: 15px;
   margin-top: 5px;
 }
 .contactSub{
   font-weight: bold;
   margin-right: 10px;
 }
 .contactRow{
   display: flex;
   flex-direction: row;
   
 }
 .ppleIcon{
 stroke: #006dff;
   fill: #006dff;
   margin-right: 5px;
font-size: 18px;
   width: 24px;
   height: 24px;
 }
 .urlLink{
   margin-left: 15px;
 }
 .tooltipIcon
 {
   font-size: 14px;
   cursor: pointer;
   color: blue;
 }
 .tooltipBox{
   font-size: 16px;
   position: absolute;
   background: #ffffff;
   padding: 15px;
   width: 370px;
   top: 20px;
   left: 320px;
   border-radius: 10px;
   box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
 }
 .tooltipTitle{
   display: flex;
   flex-direction: row;

 }
 .closeIcon{
   position: absolute;
   right: 10px;
   top: 5px;
   cursor: pointer;
 }
</style>